import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import {
  authApi,
  getAuthorizationHeader,
} from "../../../api-calls/user-requests";
import {
  GET_USER,
  LOCATION,
  MY_SUBS,
  TEAM_MEMBERS_LIST,
} from "../../../api-calls/api-urls";
import classes from "./location.module.css";
import { Checkbox, Box } from "@mui/material";
import {
  Card,
  Paper,
  CardContent,
  Avatar,
  Button,
  Typography,
} from "@mui/material";
import { generateColor, stringAvatar } from "../../../utilities/commonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getLanguagedataFunction } from "../../../utilities/language";
import {
  BrudCrumbBackIcon,
  BrudCrumbNextIcon,
} from "../../../components/Icons";
import ReassignConfirmationModal from "./ReassignModal";
import DeleteConformation from "./DeleteConformation";

const LocationReassign = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [reassignModal, setReassignModal] = useState(false);
  const [deleConfir, setDeleConfir] = useState(false);
  const [currentLocation, setCurrentLocation] = useState();
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [currentLocationUSer, setCurrentLocationUSer] = useState();
  const [teamMemberName, setTeamMemberName] = useState();
  const [loggedUser, setLoggedUser] = useState();
  const [teamMembersList, setTeamMembersList] = useState([]);
  const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
  // eslint-disable-next-line unused-imports/no-unused-vars
  const [checked, setChecked] = useState();
  const [selectedId, setSelectedId] = useState();
  const [subscriptions, setSubscriptions] = useState([]);
  const ln = useSelector((state) => state.allUsers.language_json);
  const userEntry = {
    assigned_to: selectedId,
    location_id: currentLocation ? currentLocation._id : null,
  };

  const closeModal = (status1, status2) => {
    setReassignModal(false);
    setDeleConfir(false);
    if (status2) {
      navigate("/location");
    }
  };

  React.useEffect(() => {
    getLanguagedataFunction(dispatch);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!ln]);

  const fetchSubscriptions = async () => {
    try {
      const { data } = await authApi.get(`${MY_SUBS}/${userInfo._id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      setSubscriptions(Array.isArray(data) ? data : []);
    } catch (error) {
      console.log(error);
    }
  };

  const getTeamMembersData = async () => {
    try {
      const { data } = await authApi.get(
        `${TEAM_MEMBERS_LIST}/${loggedUser.company?._id || loggedUser.company}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      console.log(data);
      setTeamMembersList(data);
    } catch (error) {
      console.log(error);
    }
  };

  // Block reassignment if the leader has no active subscription (matches backend validation).
  const isExpired = (() => {
    if (!selectedId) return false;
    if (!subscriptions || subscriptions.length === 0) return true;
    const now = new Date();
    return !subscriptions.some(
      (sub) =>
        sub.payment_status === "completed" &&
        new Date(sub.start_date) <= now &&
        new Date(sub.end_date) >= now
    );
  })();

  const handleSubmit = async () => {
    setReassignModal(true);
  };

  const handleCheckboxChange = (event) => {
    const id = event.target.id;
    setSelectedId(id);
    const data = teamMembersList.find((item) => item.user_id._id === id);
    setTeamMemberName(data?.name);
  };

  useEffect(() => {
    if (loggedUser) {
      getTeamMembersData();
      fetchSubscriptions();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!teamMembersList, loggedUser]);

  useEffect(() => {
    const path = window.location.pathname;
    //console.log(path);
    getOneLocationdata(path.toLowerCase());
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!currentLocation]);

  useEffect(() => {
    getCurrentLoggedUser();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [!loggedUser]);

  const getCurrentLoggedUser = async () => {
    try {
      const { data } = await authApi.get(`${GET_USER}/${userInfo._id}`, {
        headers: { Authorization: getAuthorizationHeader() },
      });
      //console.log(data);
      setLoggedUser(data);
    } catch (error) {
      console.log(error);
    }
  };

  const getOneUserLocation = async (item) => {
    console.log(item);
    // const { data } = await authApi.get(`${USER_LOCATION}/${item._id}`, {
    //   headers: { Authorization: getAuthorizationHeader() },
    // });
    console.log(item.userLocation.user_id);
    setSelectedId(item.userLocation.user_id._id);
  };
  const handleDeleteLocation = () => {
    setDeleConfir(true);
  };

  const getOneLocationdata = async (path) => {
    try {
      const arr = path.split("/");
      //console.log(arr[arr?.length - 1]);
      const { data } = await authApi.get(
        `${LOCATION}/${arr[arr?.length - 1]}`,
        {
          headers: { Authorization: getAuthorizationHeader() },
        }
      );
      //console.log(data.data);
      setCurrentLocation(data.data);
      getOneUserLocation(data.data);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      {ln ? (
        <div>
          <div>
            <Box className={classes.brudCrumb} sx={{ mb: 3 }}>
              <span onClick={() => navigate(-1)}>
                <BrudCrumbBackIcon />
              </span>
              <span
                onClick={() => navigate("/location")}
                className={classes.form_lable}
                style={{ color: "#0A1F41" }}
              >
                {ln.locations}
              </span>
              <BrudCrumbNextIcon />
              <span className={classes.form_lable}>
                {currentLocation ? currentLocation.title : ""}
              </span>
            </Box>
          </div>
          <div>
            <Paper className={classes.CreateTeamindex}>
              {teamMembersList && teamMembersList?.length > 0 ? (
                <div>
                  <Typography className={classes.viewstyleText}>
                    Reassign Task
                  </Typography>
                  <div
                    className={classes.GridContainer}
                    style={{ padding: "0px", marginTop: 20 }}
                  >
                    {teamMembersList.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          <Card
                            key={item._id}
                            className={`${classes.teamCard} ${classes.AssignMemberCard}`}
                          >
                            <CardContent
                              className={`${classes.teamCardContainer} ${classes.AssignMemberCard}`}
                            >
                              <Avatar
                                {...stringAvatar(item.name)}
                                style={{
                                  backgroundColor: item.department.colour
                                    ? item.department.colour
                                    : generateColor(item.name),
                                }}
                              />
                              <div className={classes.TeamcardText}>
                                <Typography
                                  className={`${classes.form_lable} ${classes.detailsText2}`}
                                >
                                  {item.name}
                                </Typography>
                                <Typography
                                  className={classes.assignMemberTeamText}
                                >
                                  Team 1
                                </Typography>
                              </div>
                              <Box>
                                <Checkbox
                                  id={item.user_id._id}
                                  checked={selectedId === item.user_id._id}
                                  onChange={handleCheckboxChange}
                                  size="small"
                                />
                              </Box>
                            </CardContent>
                          </Card>
                        </React.Fragment>
                      );
                    })}
                  </div>
                </div>
              ) : null}
              {isExpired && (
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    backgroundColor: "#FEF2F2",
                    border: "1px solid #FECACA",
                    borderRadius: 2,
                    p: 2,
                    mt: 2,
                  }}
                >
                  <span style={{ fontSize: "20px", marginTop: "2px" }}>⚠️</span>
                  <div>
                    <Typography sx={{ fontWeight: 700, color: "#991B1B", fontSize: "15px" }}>
                      Subscription Expired
                    </Typography>
                    <Typography sx={{ color: "#B91C1C", fontSize: "14px" }}>
                      The selected team member's subscription has expired. Renew it to reassign tasks.
                    </Typography>
                  </div>
                </Box>
              )}
              {teamMembersList && teamMembersList?.length > 0 ? (
                <Box sx={{ mt: 4, mb: 3 }}>
                  <Box className={classes.createLocationbtnsectin}>
                    <Button
                      variant="outlined"
                      onClick={() => handleDeleteLocation()}
                    >
                      {ln.delete_location}
                    </Button>
                    <Button
                      variant="contained"
                      onClick={() => handleSubmit()}
                      disabled={isExpired}
                    >
                      {ln.reassign_location}
                    </Button>
                  </Box>
                </Box>
              ) : null}
              {reassignModal ? (
                <ReassignConfirmationModal
                  modalClose={closeModal}
                  userEntry={userEntry}
                  teamMember={teamMemberName}
                />
              ) : null}
              {deleConfir ? (
                <DeleteConformation
                  item={currentLocation}
                  modalClose={closeModal}
                />
              ) : null}
            </Paper>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default LocationReassign;
